var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDomain24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_domain24x24",
    transform: "translate(-3 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "domain-registration",
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24976",
    "data-name": "Group 24976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24975",
    "data-name": "Group 24975",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46069",
    "data-name": "Path 46069",
    d: "M16.6,34.62H1.4A1.4,1.4,0,0,0,0,36.02v1.591a.2.2,0,0,0,.2.2H17.8a.2.2,0,0,0,.2-.2V36.02a1.4,1.4,0,0,0-1.4-1.4ZM2.524,36.667a.451.451,0,1,1,.451-.451A.451.451,0,0,1,2.524,36.667Zm1.447,0a.451.451,0,1,1,.451-.451.451.451,0,0,1-.451.451Zm1.447,0a.451.451,0,1,1,.451-.451A.451.451,0,0,1,5.418,36.667Z",
    transform: "translate(0 -34.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46070",
    "data-name": "Path 46070",
    d: "M17.8,148.15H.2a.2.2,0,0,0-.2.208v10.349a1.427,1.427,0,0,0,1.4,1.452H16.6a1.427,1.427,0,0,0,1.4-1.452V148.358a.2.2,0,0,0-.2-.208ZM6.265,153.164l-.7,2.235a.4.4,0,0,1-.33.284.4.4,0,0,1-.388-.189l-.536-.875-.536.875a.4.4,0,0,1-.388.189.4.4,0,0,1-.33-.284l-.7-2.235a.418.418,0,0,1,.257-.523.4.4,0,0,1,.5.267l.436,1.4.418-.681a.392.392,0,0,1,.675,0l.418.681.436-1.4a.4.4,0,0,1,.505-.268.42.42,0,0,1,.259.524Zm4.687,0-.7,2.235a.4.4,0,0,1-.33.284.4.4,0,0,1-.388-.189L9,154.62l-.536.875a.4.4,0,0,1-.388.189.4.4,0,0,1-.33-.283l-.7-2.235a.418.418,0,0,1,.257-.523.4.4,0,0,1,.5.267l.436,1.4.418-.681a.392.392,0,0,1,.675,0l.418.681.436-1.4a.4.4,0,0,1,.5-.268.419.419,0,0,1,.258.523Zm4.687,0-.7,2.235a.4.4,0,0,1-.33.284.4.4,0,0,1-.388-.189l-.536-.875-.536.875a.4.4,0,0,1-.388.189.4.4,0,0,1-.33-.284l-.7-2.235a.418.418,0,0,1,.257-.523.4.4,0,0,1,.5.267l.436,1.4.418-.681a.392.392,0,0,1,.675,0l.418.681.436-1.4a.4.4,0,0,1,.506-.269.42.42,0,0,1,.259.525Z",
    transform: "translate(0 -144.159)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDomain24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_domain24x24.c18dc057a95492afc779bc6588060c9e.svg";